import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

let slugs = [];
let oldPathIndex = -1;

const popSlugs = (slug) => {
  const idx = slugs.indexOf(slug);
  const howMany = idx > -1 ? slugs.length - idx : 0;
  slugs.splice(idx, howMany);
};

const useNavigationSync = ({ slug, values, handleSubmit, goBack }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (slug) {
      const hasSlugChangedByMachine = history.location.pathname !== slug;

      if (hasSlugChangedByMachine) {
        history.push(slug);
        popSlugs(slug);
      }

      const shouldStoreSlug = !slugs.includes(slug);
      if (shouldStoreSlug) {
        slugs.push(slug);
      }
    }
  }, [slug, history]);

  useEffect(() => {
    const pathIndex = slugs.indexOf(location.pathname);

    if (
      pathIndex === -1 ||
      pathIndex >= slugs.length ||
      slug === location.pathname
    ) {
      oldPathIndex = pathIndex;
      return false;
    }

    if (pathIndex > oldPathIndex) {
      handleSubmit(values);
    } else if (pathIndex < oldPathIndex) {
      goBack();
    }
  }, [location, slug, goBack, handleSubmit, values]);
};

export default useNavigationSync;
